import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { GetCaseFormsWithPagingQuery } from './get-case-forms-with-paging.query';
import { GetCaseFormsWithPagingResult } from './get-case-forms-with-paging.result';
import { CaseFormState } from '../../states/case-form.state';

@Injectable({ providedIn: 'root' })
export class GetCaseFormsWithPagingUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(query: GetCaseFormsWithPagingQuery): Observable<GetCaseFormsWithPagingResult> {
    return this._repository.getCaseFormsWithPaging(query).pipe(
      map((result) => {
        this._state.setCaseForms(result.data);
        this._state.setCaseFormsCount(result.totalElements);
        return {
          data: this._state.caseForms(),
          totalElements: result.totalElements,
        };
      }),
    );
  }
}
